<template>
  <div>
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      v-model="modalVisivel"
      @hidden="onModalClose"
      :hide-footer="isGerandoRelatorio"
      :hide-header-close="isGerandoRelatorio"
      :size="isGerandoRelatorio ? 'md' : 'lg'"
    >
      <template #modal-title>
        {{
          isGerandoRelatorio ? "Processando Dados" : "Movimentações por Projeto"
        }}
      </template>

      <transition name="fade" mode="out-in">
        <div v-if="isGerandoRelatorio" class="text-center py-2">
          <div class="d-flex justify-content-center align-items-center mb-3">
            <b-spinner class="mb-2" variant="primary" />
          </div>
          <h5 class="font-weight-bold mb-3">{{ mensagemStatus }}</h5>

          <b-progress
            :max="100"
            class="mt-3"
            height="20px"
            variant="success"
            :value="progresso"
            show-progress
          >
            <b-progress-bar
              :striped="progresso < 100"
              :animated="progresso < 100"
              :value="progresso"
              :label="progresso === 100 ? 'Concluído!' : `${progresso}%`"
            />
          </b-progress>
        </div>

        <div v-else>
          <div class="row d-flex mb-3">
            <div class="col-md-6">
              <SelectCooperado
                :state="stateCooperado"
                v-model="selecaoCooperado"
              />
            </div>
            <div class="col-md-6">
              <SelectSafra :state="stateSafra" v-model="selecaoSafra" />
            </div>
          </div>

          <div class="row d-flex mb-3">
            <div class="col-md-6">
              <SelectTipoDeProjeto
                :state="stateTipoProjeto"
                class="select-tipo-projeto"
                v-model="selecaoTipoProjeto"
                :disabled-select="!podeGerarRelatorio"
                :invalid-feedback="feedbackTipoProjeto"
              />
            </div>
            <div class="col-md-6">
              <SelectItemAgropecuario
                :safra="selecaoSafra"
                :safra-obrigatoria="true"
                :tp-projeto-obrigatorio="true"
                ref="selectItemAgropecuarioRef"
                v-model="selecaoItemAgropecuario"
                :tipo-projeto="selecaoTipoProjeto"
                :disabled-select="!podeGerarRelatorio"
                @limpar-validacao="handleLimparValidacao"
                :erro-pre-requisito="mostrarErroPreRequisito"
                :mensagem-erro="mensagemErroItemAgropecuario"
                @validar-safra-tipo="handleValidacaoSafraTipo"
              />
            </div>
          </div>

          <div class="row d-flex">
            <div class="col-md-6">
              <SelectInstituicaoFinanceira
                :disabled-select="!podeGerarRelatorio"
                v-model="selecaoInstituicaoFinanceira"
              />
            </div>
            <div class="col-md-6">
              <SelectStatusProjeto
                :disabled-select="!podeGerarRelatorio"
                v-model="selecaoStatusProjeto"
              />
            </div>
          </div>
        </div>
      </transition>

      <template v-slot:modal-footer>
        <div class="w-100 d-flex align-items-center justify-content-end gap-2">
          <b-button
            variant="success"
            @click="consultar"
            :disabled="!podeGerarRelatorio"
          >
            <i class="fas fa-download me-1"></i>
            <span>Gerar Relatório</span>
          </b-button>

          <b-button
            class="button-fechar-modal"
            v-if="!isGerandoRelatorio"
            variant="secondary"
            @click="fecharModal"
          >
            <i class="mdi mdi-close me-1"></i>
            <span>Fechar</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script lang="js">
import SelectSafra from "../inputs/SelectSafra.vue";
import SelectCooperado from '../inputs/SelectCooperado.vue';
import SelectTipoDeProjeto from "../inputs/SelectTipoDeProjeto.vue";
import SelectStatusProjeto from "../inputs/SelectStatusProjeto.vue";
import { MovimentacaoService } from '../../../../../services/astec/movimentacao';
import SelectItemAgropecuario from "../inputs/SelectItemAgropecuario.vue";
import SelectInstituicaoFinanceira from "../inputs/SelectInstituicaoFinanceira.vue";

export default {
  name: "RelatorioMovimentacoes",
  components: {
    SelectSafra,
    SelectCooperado,
    SelectTipoDeProjeto,
    SelectStatusProjeto,
    SelectItemAgropecuario,
    SelectInstituicaoFinanceira,
  },

  props: {
    isOpenModal: {
      type: Boolean,
      default: false
    },
    filtrosDeProjetos: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      progresso: 0,
      desabilita: false,
      selecaoSafra: null,
      validaState: false,
      modalVisivel: false,
      tempoFeedback: null,
      selecaoCooperado: null,
      progressInterval: null,
      selecaoTipoProjeto: null,
      feedbackTipoProjeto: "",
      isGerandoRelatorio: false,
      selecaoStatusProjeto: null,
      destacarTipoProjeto: false,
      selecaoItemAgropecuario: null,
      validaSafraObrigatoria: false,
      mostrarErroPreRequisito: false,
      mensagemErroItemAgropecuario: "",
      mostrarErroItemAgropecuario: false,
      selecaoInstituicaoFinanceira: null,
      jaCarregouDoVuexNestaSessao: false,
      validaTipoProjetoObrigatorio: false,
      tentouSelecionarItemAgropecuario: false,
      mensagemStatus: "Por favor, aguarde enquanto geramos seu relatório..",

    };
  },

  watch: {
    selecaoTipoProjeto(newVal) {
      if (newVal) {
        this.mostrarErroPreRequisito = false;
        this.mensagemErroItemAgropecuario = "";
        this.destacarTipoProjeto = false;
        this.feedbackTipoProjeto = "";

        if (this.tempoFeedback) {
          clearTimeout(this.tempoFeedback);
          this.tempoFeedback = null;
        }
      }
    },

    selecaoSafra(newVal) {
      if (newVal === null) {
        this.selecaoItemAgropecuario = null;
      }
    },

    selecaoItemAgropecuario(newVal) {
      if (newVal) {
        this.mostrarErroPreRequisito = false;
        this.mensagemErroItemAgropecuario = "";
      }
    },

    isOpenModal(valorModal) {
      if (valorModal) {
        this.modalVisivel = valorModal;
        if (!this.jaCarregouDoVuexNestaSessao) {
          this.carregarFiltrosDoVuex();
          this.jaCarregouDoVuexNestaSessao = true;
        } else {
          this.limparSelecoes();
        }
      }
    },
  },

  computed: {
    stateCooperado() {
      if (this.selecaoCooperado) return true;
      if (this.validaState) return false;
      return null;
    },

    stateSafra() {
      if (this.selecaoSafra) return true;
      if (this.validaState) return false;
      return null;
    },

    filtrosRecebidos() {
      const filtros = {};

      Object.keys(this.filtrosDeProjetos).forEach(key => {
        const valor = this.filtrosDeProjetos[key];
        if (valor !== null && valor !== undefined && valor !== '') {
          if (typeof valor === 'object') {
            if (Object.keys(valor).length > 0) {
              filtros[key] = valor;
            }
          } else {
            filtros[key] = valor;
          }
        }
      });

      return filtros;
    },

    podeGerarRelatorio() {
      const hasSafra = this.selecaoSafra !== null;
      const hasCooperado = this.selecaoCooperado !== null;

      return hasSafra && hasCooperado;
    },

    stateTipoProjeto() {
      if (this.destacarTipoProjeto) {
        return false;
      }
      if (this.selecaoTipoProjeto) {
        return true;
      }
      return null;
    },
  },

  methods: {
    carregarFiltrosDoVuex() {
      this.limparSelecoes();

      if (this.filtrosRecebidos.cooperado) {
        this.selecaoCooperado = this.filtrosRecebidos.cooperado;
      }

      if (this.filtrosRecebidos.safra) {
        this.selecaoSafra = this.filtrosRecebidos.safra;
      }

      if (this.filtrosRecebidos.tipoProjeto) {
        this.selecaoTipoProjeto = this.filtrosRecebidos.tipoProjeto;
      }

      if (this.filtrosRecebidos.itemAgropecuario) {
        this.selecaoItemAgropecuario = this.filtrosRecebidos.itemAgropecuario;
      }

      if (this.filtrosRecebidos.instituicaoFinanceira) {
        this.selecaoInstituicaoFinanceira = this.filtrosRecebidos.instituicaoFinanceira;
      }

      if (this.filtrosRecebidos.statusProjeto) {
        this.selecaoStatusProjeto = this.filtrosRecebidos.statusProjeto;
      }
    },

    handleValidacaoSafraTipo(safraFalta, tipoProjetoFalta) {
      this.validaSafraObrigatoria = safraFalta;
      this.validaTipoProjetoObrigatorio = tipoProjetoFalta;
      if (tipoProjetoFalta) {
        this.destacarCampoTipoProjeto();
      }
    },

    // Método para destacar o campo Tipo de Projeto
    destacarCampoTipoProjeto() {
      this.destacarTipoProjeto = true;
      this.feedbackTipoProjeto = "Selecione o Tipo de Projeto para habilitar o Item Agropecuário";

      if (this.tempoFeedback) {
        clearTimeout(this.tempoFeedback);
      }

      this.tempoFeedback = setTimeout(() => {
        this.destacarTipoProjeto = false;
        this.feedbackTipoProjeto = "";
      }, 5000);
    },

    handleLimparValidacao() {
      this.validaSafraObrigatoria = false;
      this.validaTipoProjetoObrigatorio = false;
      this.destacarTipoProjeto = false;
      this.feedbackTipoProjeto = "";

      if (this.tempoFeedback) {
        clearTimeout(this.tempoFeedback);
        this.tempoFeedback = null;
      }
    },

    consultar() {
      const dados = {
        safra: this.selecaoSafra.name || null,
        cooperado: this.selecaoCooperado?.value || null,
        tipoProjeto: this.selecaoTipoProjeto?.value || null,
        itemAgropecuario: this.selecaoItemAgropecuario?.value || null,
        banco: this.selecaoInstituicaoFinanceira?.value || this.selecaoInstituicaoFinanceira?.id || null,
        status: this.selecaoStatusProjeto?.value || this.selecaoStatusProjeto?.id || null,
      };

      const dadosFiltrados = Object.fromEntries(
        Object.entries(dados).filter(([, value]) => value != null)
      );

      this.processarRelatorio(dadosFiltrados);
    },

    iniciarProgressoFake() {
      this.progresso = 0;

      this.progressInterval = setInterval(() => {
        if (this.progresso < 30) {
          this.progresso += 4;
        } else if (this.progresso < 70) {
          this.progresso += 2;
        } else if (this.progresso < 92) {
          this.progresso += 0.5;
        }

        if (this.progresso < 40) {
          this.mensagemStatus = "Coletando dados...";
        } else if (this.progresso < 75) {
          this.mensagemStatus = "Processando informações...";
        } else {
          this.mensagemStatus = "Gerando PDF...";
        }
      }, 800);
    },

    async processarRelatorio(dados) {
      this.isGerandoRelatorio = true;
      this.mensagemStatus = "Gerando relatório...";
      this.iniciarProgressoFake();

      const inicio = Date.now();
      let pdfUrl = null;

      try {
        const response =
          await MovimentacaoService.buscaRelatorioMovimentacaoPentaho(dados);

        const tempoMinimo = 2000;
        const decorrido = Date.now() - inicio;
        if (decorrido < tempoMinimo) {
          await this.delay(tempoMinimo - decorrido);
        }

        clearInterval(this.progressInterval);
        this.progresso = 95;
        this.mensagemStatus = "Finalizando PDF...";

        const pdfBlob = new Blob([response], { type: "application/pdf" });
        pdfUrl = URL.createObjectURL(pdfBlob);

        window.open(pdfUrl, "_blank");

        this.progresso = 100;
        this.mensagemStatus = "Concluído!";

        setTimeout(() => {
          this.$tools.alerta("Relatório gerado com sucesso!", "success");
          this.isGerandoRelatorio = false;
          this.modalVisivel = false;
          this.progresso = 0;
          this.limparSelecoes();
          this.$emit("fechar");
        }, 1500);

      } catch (error) {
        console.error("Erro ao gerar PDF de Movimentações:", error);

        let mensagemErro =
          "Erro ao gerar relatório de movimentações.";
        if (error.response && error.response.status === 404) {
          mensagemErro =
            "Nenhum dado de movimentação encontrado para os filtros selecionados.";
        }

        this.$tools.alerta(mensagemErro, "error");
        this.isGerandoRelatorio = false;

      } finally {
        clearInterval(this.progressInterval);

        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }

        this.mensagemStatus = "Por favor, aguarde enquanto geramos seu relatório...";
        this.limparSelecoes();
      }
    },
    delay(ms) {
      return new Promise((res) => setTimeout(res, ms));
    },

    limparSelecoes() {
      this.selecaoSafra = null;
      this.selecaoCooperado = null;
      this.selecaoTipoProjeto = null;
      this.selecaoStatusProjeto = null;
      this.selecaoItemAgropecuario = null;
      this.selecaoInstituicaoFinanceira = null;

      this.validaState = false;
      this.mostrarErroPreRequisito = false;
      this.mensagemErroItemAgropecuario = "";
      this.destacarTipoProjeto = false;
      this.feedbackTipoProjeto = "";

      if (this.tempoFeedback) {
        clearTimeout(this.tempoFeedback);
        this.tempoFeedback = null;
      }
    },

    fecharModal() {
      this.modalVisivel = false;
      this.$emit("fechar");
    },

    onModalClose() {
      if (this.progressInterval) clearInterval(this.progressInterval);
      this.isGerandoRelatorio = false;
      this.progresso = 0;
      this.mensagemStatus = "Por favor, aguarde enquanto geramos seu relatório..";
      this.$emit("fechar");
      this.limparSelecoes();
    },
  },
};
</script>

<style lang="css" scoped>
.button-fechar-modal {
  width: 140px;
}
</style>
